"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { insightArticles } from "@/lib/data/insights";
import { SectionHeader } from "@/components/ui/section-header";
import { Button } from "@/components/ui/button";

export function InsightsPreview() {
  const featured = insightArticles.find((i) => i.featured) ?? insightArticles[0];
  const rest = insightArticles.filter((i) => i.slug !== featured.slug).slice(0, 4);

  return (
    <section className="relative overflow-hidden py-16 sm:py-24 md:py-32">
      <div className="container-wide">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeader
            eyebrow="Insights"
            title={"KNOWLEDGE FOR\nTHE AI ERA"}
            description="Perspectives, research, and practical guidance for leaders building intelligent enterprises."
          />
          <Button href="/insights" variant="outline" arrow cursorLabel="OPEN">
            View all insights
          </Button>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-[1.2fr_0.8fr]">
          <motion.article
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-[2rem] border border-border bg-surface p-8 md:min-h-[420px] md:p-10"
          >
            <div className="aurora opacity-60" />
            <div className="relative">
              <p className="text-xs uppercase tracking-[0.18em] text-muted">
                {featured.type} · {featured.category} · {featured.readTime}
              </p>
              <h3 className="mt-5 max-w-xl font-display text-4xl tracking-tight md:text-5xl">
                {featured.title}
              </h3>
              <Link
                href={`/insights/${featured.slug}`}
                className="mt-8 inline-flex text-sm font-medium hover:text-accent"
              >
                Read featured perspective →
              </Link>
            </div>
          </motion.article>

          <div className="space-y-4">
            {rest.map((item, index) => (
              <motion.article
                key={item.slug}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="rounded-[1.5rem] border border-border bg-card p-5"
              >
                <p className="text-xs uppercase tracking-[0.16em] text-muted">
                  {item.type} · {item.category}
                </p>
                <Link
                  href={`/insights/${item.slug}`}
                  className="mt-2 block font-display text-xl tracking-tight hover:text-accent"
                >
                  {item.title}
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
